import React from 'react'

import StandardLayout from '@@layouts/StandardLayout'
import SEO from '@@components/seo'
import HomepageArticles from '@@components/HomepageArticles'
import { useGetAllArticles } from '@@root/hooks'

export const Homepage = () => {
  const articles = useGetAllArticles()

  return (
    <StandardLayout>
      <SEO title="James N. Campbell" />
      <HomepageArticles articles={articles} />
    </StandardLayout>
  )
}
